import CombineItemInfoDTO from "@/dto/order/CombineItemInfoDTO";
import OrderStatus from "@/enum/OrderStatus";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React, { useState } from "react";
import OrderItemStatusLabel from "@/components/OrderItemImage/OrderItemStatusLabel";

interface CombineItemInfosProps {
    combineItemInfos: CombineItemInfoDTO[];

    orderItemStatus: OrderStatus;
}

const CombineItemInfos: React.FC<CombineItemInfosProps> = function (props) {
    const { combineItemInfos, orderItemStatus } = props;
    const [open, updateOpen] = useState(false);

    function buildCombineItemInfos() {
        if (!open) return null;

        return combineItemInfos?.map((item) => {
            return (
                <div key={item.itemId} className="text-secondary">
                    {orderItemStatus !== item.status && (
                        <>
                            <OrderItemStatusLabel status={item.status} />
                            &nbsp;
                        </>
                    )}
                    {item.itemName}&nbsp;*&nbsp;{item.quantity}
                </div>
            );
        });
    }

    return (
        <div>
            <div>
                组合品详情:
                <Button
                    type="link"
                    className="fs12 ml5"
                    onClick={() => {
                        updateOpen(!open);
                    }}
                >
                    {open ? (
                        <span>
                            收起
                            <UpOutlined />
                        </span>
                    ) : (
                        <span>
                            展开
                            <DownOutlined />
                        </span>
                    )}
                </Button>
            </div>

            {buildCombineItemInfos()}
        </div>
    );
};

export default React.memo(CombineItemInfos);
